module.exports = "/currency/assets/dd769f2c80af872cce3cd87bdded733b.jpg";